import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Fleet from "@/components/Fleet";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import MobileCallBar from "@/components/MobileCallBar";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="grid min-h-screen place-items-center bg-ink font-sans text-white">
          <p>Something went wrong — please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="grain min-h-screen bg-ink font-sans text-white antialiased">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Fleet />
          <ContactSection />
        </main>
        <Footer />
        <MobileCallBar />
      </div>
    </ErrorBoundary>
  );
}

export default App;
